// src/app/meter/components/meter-list/meter-unassigned/meter-unassigned.component.ts

import { Component, OnInit, OnDestroy } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MeterAbstractService } from '../../../services/meter.abstract.service';
import { MeterItem } from '../../../models/meter-manage.model';

@Component({
    selector: 'app-meter-unassigned',
    templateUrl: './meter-unassigned.component.html',
    styleUrls: ['./meter-unassigned.component.scss'],
})
export class MeterUnassignedComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    displayedColumns: string[] = ['nodeId', 'nodeType', 'address', 'lastMeterReadAt'];
    meters: MeterItem[] = [];
    total = 0;
    pageSize = 20;
    pageIndex = 0;
    loading = false;

    constructor(private meterService: MeterAbstractService) {}

    ngOnInit(): void {
        this.loadUnassigned();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onPageChange(event: PageEvent): void {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.loadUnassigned();
    }

    formatAddress(meter: MeterItem): string {
        const parts = [meter.address.street];
        if (meter.address.unit) {
            parts.push(`Unit ${meter.address.unit}`);
        }
        parts.push(meter.address.postCode);
        return parts.join(', ');
    }

    private loadUnassigned(): void {
        this.loading = true;
        this.meterService
            .getUnassigned(this.pageIndex + 1, this.pageSize)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (result) => {
                    this.meters = result.data;
                    this.total = result.total;
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                },
            });
    }
}
